import { AdjustMonthDay } from "./AdjustMonthDay";
import { enumLanguage } from "../constants";
import { SanitizeDate } from "./SanitizeDate";
import { GetCurrentLanguage } from "./GetCurrentLanguage";

export function ConvertToDate(value) {
  if (typeof value === "number") return Number.isNaN(value) ? null : value; // Already a timestamp
  if (value && value.length > 0) {
    var cLanguage = GetCurrentLanguage();
    if (cLanguage == enumLanguage.french) value = AdjustMonthDay(value);
    var d = Date.parse(value);
    if (isNaN(d)) d = SanitizeDate(value);
    return isNaN(d) ? null : d;
  }

  return null;
}
